import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Route, Switch, withRouter, NavLink } from 'react-router-dom'
import { fetchDetails, resetDetails } from '../actions'
import Loader from '../components/_common/Loader'

import PropertyDetail from '../components/Properties/PropertyDetail'
import Faq from '../components/Properties/Faq'
import Manuals from '../components/Properties/Manuals'
import NearbyInformations from '../components/Properties/NearbyInformations'
import Guides from '../components/Properties/Guides'
import Guide from '../components/Properties/Guides/Guide'
import Equipments from '../components/Properties/Equipments'
import Garbage from '../components/Properties/Garbage'
import Pickup from '../components/Properties/Pickup'
import PublicFacilities from '../components/Properties/PublicFacilities'

import PropertyResidents from '../components/Properties/PropertyResidents'
import AddResident from '../components/Residents/AddResident'

class PropertyRoutes extends PureComponent {
  componentDidMount () {
    this.props.fetchDetails('properties', this.props.match.params.id)
  }
  componentWillUnmount () {
    this.props.resetDetails()
  }

  _renderRoomCount () {
    return (
      <div className="label_group flex column">
        <div className="label">総世帯数</div>
        <div className="value">{this.props.activeDetails.data.room_count}</div>
      </div>
    )
  }
  _renderTabBtns () {
    const { url } = this.props.match
    if (this.props.location.pathname.indexOf(`${url}/residents`) !== -1) {
      return null
    }
    if (this.props.activeDetails.data.owner_id === 1) {
      return (
        <div key="tabLinks" className="tab_links flex align-center">
          <NavLink to={`${url}`} exact className="tab_link">物件詳細</NavLink>
          <NavLink to={`${url}/faq`} className="tab_link">よくある質問一覧</NavLink>
          <NavLink to={`${url}/pickup`} className="tab_link">ピックアップ</NavLink>
        </div>
      )
    } else {
      return (
        <div key="tabLinks" className="tab_links flex align-center">
          <NavLink to={`${url}`} exact className="tab_link">物件詳細</NavLink>
          <NavLink to={`${url}/faq`} className="tab_link">よくある質問一覧</NavLink>
          <NavLink to={`${url}/manuals`} className="tab_link">取説一覧</NavLink>
          <NavLink to={`${url}/nearby_informations`} className="tab_link">周辺情報一覧</NavLink>
          <NavLink to={`${url}/guides`} className="tab_link">各種ご案内一覧</NavLink>
          <NavLink to={`${url}/equipments`} className="tab_link">各種設備一覧</NavLink>
          <NavLink to={`${url}/garbage`} className="tab_link">ごみカレンダー</NavLink>
          <NavLink to={`${url}/pickup`} className="tab_link">ピックアップ</NavLink>
          <NavLink to={`${url}/public_facilities`} className="tab_link">公共サービス一覧</NavLink>
        </div>
      )
    }
  }

  render () {
    const { location } = this.props
    const { url } = this.props.match
    const { bits_property_id, property_name } = this.props.activeDetails.data

    if (this.props.activeDetails.loading) {
      return <Loader classname="loader_dot_circle"/>
    }

    return [
      <header className="details_header flex" key="header">
        <div className="label_group flex column">
          <div className="label">BITS物件ID</div>
          <div className="value">{bits_property_id}</div>
        </div>
        <div className="label_group flex column">
          <div className="label">物件名</div>
          <div className="value">{property_name}</div>
        </div>
        { this._renderRoomCount() }
      </header>,
      this._renderTabBtns(),
      <section className="details property_details" key="details">
        <Switch location={location}>
          <Route path={`${url}`} exact component={PropertyDetail} />
          <Route path={`${url}/faq`} render={ () => <Faq propertyID={this.props.match.params.id}/> } />
          <Route path={`${url}/manuals`} render={ () => <Manuals propertyID={this.props.match.params.id}/> } />
          <Route path={`${url}/nearby_informations`} render={ () => <NearbyInformations propertyID={this.props.match.params.id}/> } />
          <Route path={`${url}/guides`} exact render={ () => <Guides propertyID={this.props.match.params.id}/> } />
          <Route path={`${url}/guides/:guide_id`} render={ () => <Guide propertyID={this.props.match.params.id}/> } />
          <Route path={`${url}/equipments`} render={ () => <Equipments propertyID={this.props.match.params.id}/> } />
          <Route path={`${url}/garbage`} render={ () => <Garbage propertyID={this.props.match.params.id}/> } />
          <Route path={`${url}/pickup`} render={ () => <Pickup propertyID={this.props.match.params.id}/> } />
          <Route path={`${url}/public_facilities`} render={ () => <PublicFacilities propertyID={this.props.match.params.id}/> } />

          <Route
            path={`${url}/residents`}
            exact
            render={ () => <PropertyResidents roomCount={this.props.activeDetails.data.room_count} propertyID={this.props.match.params.id}/> }
          />
          <Route path={`${url}/residents/add`} exact render={ () => <AddResident propertyID={this.props.match.params.id}/> } />
        </Switch>
      </section>
    ]
  }
}

// export default withRouter(PropertyRoutes)

function mapStateToProps ({ activeDetails }) {
  return { activeDetails }
}

export default withRouter(connect(mapStateToProps, { fetchDetails, resetDetails })(PropertyRoutes))



// WEBPACK FOOTER //
// ./src/routes/PropertyRoutes.jsx